module.exports = __webpack_public_path__ + "static/media/io.a675b901.svg";